  import React, { useState, useEffect, useRef } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import './footer.css';
import { useContent } from '../hooks/useContent'


const Footer = () => {
  const navigate = useNavigate()
  const { content: footerContent } = useContent('footer')

  const description = footerContent?.description || 'A secluded haven in the untouched village of Poondi, where\n                nature and comfort come together. Experience sustainable living\n                in harmony with the mountains.'
  const contact = footerContent?.contact || {
    address: '39th km, Kodai-Munnar road, Poondi, Kodaikanal, Tamil Nadu 624103',
    phone: '+91 98765 43210',
    email: 'info@ampthilldowns.com',
    hours: 'Mon - Sun: 24/7 Support',
  }

  return (
    <footer className='footer-section'>
      <Container>
        <Row className='gy-4'>
            <Col xs={12} lg={4}>
              <h4 className='footer-heading'>Ampthilldowns</h4>
              <p className='footer-description'>
                {description}
              </p>
             {/* Social Media Icons */}
<div className="social-icons">
  <a href="https://www.facebook.com/Ampthilldowns/" target="_blank" rel="noopener noreferrer" className="social-icon facebook">
    <span></span>
    <span></span>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
    </svg>
  </a>

  <a href="https://www.instagram.com/ampthill_downs?igsh=b2FhOTR2eG52aTh3" target="_blank" rel="noopener noreferrer" className="social-icon instagram">
    <span></span>
    <span></span>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
    </svg>
  </a>
<a href="https://x.com/ampthilldowns" target="_blank" rel="noopener noreferrer" className="social-icon twitter">
  <span></span>
  <span></span>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2H21.5l-7.51 8.574L23 22h-6.843l-5.354-6.852L4.5 22H1.244l8.05-9.187L1 2h6.97l4.78 6.082L18.244 2zm-2.403 17h1.87L8.24 4.953H6.255L15.84 19z"/>
  </svg>
</a>


  <a href="https://www.linkedin.com/ampthill-downs?_l=en_US" target="_blank" rel="noopener noreferrer" className="social-icon linkedin">
    <span></span>
    <span></span>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
  </a>

  <a href="https://www.youtube.com/channel/UCT1-ZO04pfa9cA2Miz1oR6A" target="_blank" rel="noopener noreferrer" className="social-icon youtube">
    <span></span>
    <span></span>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
    </svg>
  </a>
</div>

            </Col>
            <Col xs={12} sm={6} lg={2}>
              <h4 className='footer-heading'>Explore</h4>
              <ul className='footer-links'>
                <li>
                  <a
                    onClick={() => {
                      navigate('/')
                      window.scrollTo({ top: 0, behavior: 'smooth' })
                    }}
                  >
                    Home
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => {
                      navigate('/our-story')
                      window.scrollTo({ top: 0, behavior: 'smooth' })
                    }}
                  >
                    Our Story
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => {
                      navigate('/the-farm')
                      window.scrollTo({ top: 0, behavior: 'smooth' })
                    }}
                  >
                    The Farm
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => {
                      navigate('/stays')
                      window.scrollTo({ top: 0, behavior: 'smooth' })
                    }}
                  >
                    Stays
                  </a>
                </li>
                <li>
                  <a
                    onClick={() => {
                      navigate('/experiences')
                      window.scrollTo({ top: 0, behavior: 'smooth' })
                    }}
                  >
                    Experiences
                  </a>
                </li>
              </ul>
            </Col>
            <Col xs={12} sm={6} lg={3}>
              <h4 className='footer-heading'>Quick Links</h4>
              <ul className='footer-links'>
                <li>
                  <a
                    onClick={() => {
                      navigate('/plan-your-journey')
                      window.scrollTo({ top: 0, behavior: 'smooth' })
                    }}
                  >
                    Plan Your Journey
                  </a>
                </li>
                <li>
                  <a href='/gallery'>Gallery</a>
                </li>
                <li>
                  <a href='/contact'>Contact Us</a>
                </li>
              </ul>
            </Col>
            <Col xs={12} lg={3}>
              <h4 className='footer-heading'>Contact Us</h4>
              <ul className='footer-contact'>
                <li>
                  <i className='fas fa-map-marker-alt'></i>
                  <span>{contact.address}</span>
                </li>
                <li>
                  <i className='fas fa-phone'></i>
                  <span>{contact.phone}</span>
                </li>
                <li>
                  <i className='fas fa-envelope'></i>
                  <span>{contact.email}</span>
                </li>
                <li>
                  <i className='fas fa-clock'></i>
                  <span>{contact.hours}</span>
                </li>
              </ul>
            </Col>
          </Row>
          <Row className='footer-bottom'>
            <Col xs={12} md={6} className='text-center text-md-start'>
              <p className='copyright-text'>
                © {new Date().getFullYear()} Ampthilldowns. All rights reserved.
              </p>
            </Col>
            <Col xs={12} md={6} className='text-center text-md-end'>
            </Col>
          </Row>
        </Container>
      </footer>
  )
}

export default Footer